import logo from "@/assets/extone-drive-logo.svg";

/** Brand artwork copied from extone_portal/src/components/DriveLogo.astro. */
export function DriveLogo() {
  return <img src={logo} alt="EXTONE Drive" width={491} height={50} className="block h-auto w-[200px] max-w-full" />;
}
